import { TableHeader, TableRow, TableHead } from "@/components/ui/table";
import { flexRender, Table } from "@tanstack/react-table";

export function DataTableHeader<TData>({ table }: { table: Table<TData> }) {
    return (
        <TableHeader className="sticky top-0 z-30 border-b border-gray-300 bg-white">
            {table.getHeaderGroups().map((headerGroup) => (
                <TableRow key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                        return (
                            <TableHead className="text-left" key={header.id}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                          header.column.columnDef.header,
                                          header.getContext(),
                                      )}
                            </TableHead>
                        );
                    })}
                </TableRow>
            ))}
        </TableHeader>
    );
}
